<template>
  <v-container class="fill-height">
    <v-container class="d-flex justify-center mt-2 mt-sm-2 mt-md-6 mt-lg-10 mt-xl-10 flex-wrap" v-if="$vuetify.breakpoint.smAndDown">
      <v-img src="../assets/world-map-colortwo.png" height="200" contain style="z-index: 0;position: absolute;"></v-img>
      <v-container style="position: relative; z-index: 1; height: 200px;" class="d-flex justify-center align-center flex-wrap">
        <p class="text-center my-custom-font-title text-h4 text-sm-h3 text-md-h1 text-lg-h1 text-xl-h1 font-weight-black">All Phone Numbers</p>
      </v-container>
    </v-container>
    <v-container class="d-flex justify-center mt-2 mt-sm-2 mt-md-6 mt-lg-10 mt-xl-10 flex-wrap" v-else>
      <v-img src="../assets/world-map-colortwo.png" height="500" contain style="z-index: 0;position: absolute;"></v-img>
      <v-container style="position: relative; z-index: 1; height: 500px;" class="d-flex justify-center align-center flex-wrap">
        <p class="text-center my-custom-font-title text-h4 text-sm-h3 text-md-h1 text-lg-h1 text-xl-h1 font-weight-black">All Phone Numbers</p>
      </v-container>
    </v-container>
    
    <v-container class="text-center">
      <p class="my-custom-font-explain text-h6 text-sm-h5 text-md-h4 text-lg-h4 text-xl-h4 font-weight-black mt-4 mb-4">How to receive SMS online ?</p>
    </v-container>
    <v-row>
        <v-col cols="12" sm="12" md="2" lg="2" xl="2" v-if="$vuetify.breakpoint.smAndDown">
        </v-col>
        <v-col cols="12" sm="12" md="2" lg="2" xl="2" v-else>
          <!-- <AdsBar /> -->
        </v-col>
        <v-col cols="12" sm="12" md="8" lg="8" xl="8" class="mx-auto">
          <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="mx-auto">
            <v-card elevation="2" class='py-4 px-4'>
              <span class="mr-2" style="vertical-align:middle;">
                <svg t="1680591155677" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4002" width="32" height="32">
                  <path d="M512 899.5c-213.668 0-387.5-173.832-387.5-387.5S298.332 124.5 512 124.5 899.5 298.332 899.5 512 725.668 899.5 512 899.5z" fill="#4472C4" p-id="4003"></path>
                  <path d="M512 137c-206.776 0-375 168.224-375 375s168.224 375 375 375 375-168.224 375-375-168.224-375-375-375m0-25c220.914 0 400 179.086 400 400S732.914 912 512 912 112 732.914 112 512s179.086-400 400-400z" fill="#4472C4" p-id="4004"></path>
                  <path d="M597.681 335.009c0-7.67-2.36-13.569-7.08-17.109a35.115 35.115 0 0 0-20.061-5.9c-3.54 0-6.49 1.77-10.029 4.13-3.54 2.95-6.49 5.31-8.26 7.08a75.758 75.758 0 0 0-11.211 13.569c-3.54 4.72-7.67 9.44-11.209 13.569-11.209 12.979-23.009 27.139-35.988 41.3-13.569 14.749-26.549 27.729-38.938 39.528-1.18 1.18-2.95 2.36-4.13 3.54l-4.72 2.36c-1.77 1.18-3.54 1.77-4.72 2.95l-5.31 3.54c-2.95 2.36-5.31 4.13-7.08 5.9-2.36 2.36-2.95 4.13-2.95 5.9 0 7.08 2.95 12.389 10.03 16.519 5.9 4.72 12.979 6.49 20.059 6.49a31.985 31.985 0 0 0 14.756-3.543c4.13-2.36 8.26-5.9 12.979-10.619 2.95-3.54 6.49-7.67 11.209-12.979l11.8-12.979c2.95-2.95 7.67-7.67 13.569-14.159s12.389-14.159 20.649-23.009c-1.77 9.44-3.54 20.649-4.72 33.628-2.36 12.979-4.13 25.959-5.9 40.118l-4.72 41.888c-1.18 14.159-2.36 27.729-2.95 39.528-1.18 22.419-2.36 44.838-2.95 67.257q-1.77 33.628-1.77 58.407c0 9.44 2.36 16.519 7.67 21.829 5.31 5.9 12.389 8.26 21.829 8.26a43.479 43.479 0 0 0 15.929-3.54c4.72-2.36 7.67-5.31 7.67-8.85 0-1.77-0.59-5.31-0.59-11.209a149.392 149.392 0 0 1-2.36-18.879 116.91 116.91 0 0 1-2.36-21.239 132.008 132.008 0 0 1-1.18-20.649c0-41.3 1.18-82.6 4.72-124.484 3.54-41.3 10.03-82.6 20.649-123.3a106.366 106.366 0 0 1 2.95-11.209l2.36-11.209 1.77-11.209c-0.002-3.547 0.588-7.086 0.588-11.216z" fill="#FFFFFF" p-id="4005"></path>
                </svg>
              </span>
              <span>Choose a phone number from the list below</span>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="mx-auto">
            <v-card elevation="2" class='py-4 px-4'>
              <span class="mr-2" style="vertical-align:middle;">
                <svg t="1680591193411" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4636" width="32" height="32">
                  <path d="M512 899.5c-213.668 0-387.5-173.832-387.5-387.5S298.332 124.5 512 124.5 899.5 298.332 899.5 512 725.668 899.5 512 899.5z" fill="#4472C4" p-id="4637"></path>
                  <path d="M512 137c-206.776 0-375 168.224-375 375s168.224 375 375 375 375-168.224 375-375-168.224-375-375-375m0-25c220.914 0 400 179.086 400 400S732.914 912 512 912 112 732.914 112 512s179.086-400 400-400z" fill="#4472C4" p-id="4638"></path>
                  <path d="M658.94 684.941c0-8.235-2.941-15.294-8.235-22.353S639.529 652 632.471 652a64.116 64.116 0 0 0-15.294 1.765l-8.235 1.765-8.235 1.176c-12.941 1.176-25.882 2.353-39.412 2.353-14.118 0-27.059 0.588-39.412 1.176-11.765 1.176-24.118 1.765-37.059 2.353-12.941 1.176-29.412 2.353-48.824 4.706 13.529-11.176 24.706-21.176 33.529-29.412l24.118-22.941 39.412-38.235c12.941-12.941 25.881-25.294 39.412-38.235a170.839 170.839 0 0 0 38.235-57.059 184.229 184.229 0 0 0 12.353-67.647c0-12.353-2.941-24.706-8.235-37.059a138.277 138.277 0 0 0-22.941-32.941 121.843 121.843 0 0 0-35.294-22.941A108.656 108.656 0 0 0 513.06 312a180.13 180.13 0 0 0-50 7.059 125.575 125.575 0 0 0-44.12 24.706c-4.706 3.529-8.824 8.824-13.529 14.706-4.706 6.471-9.412 12.941-12.941 20a114.8 114.8 0 0 0-10 21.176 49.641 49.641 0 0 0-4.118 18.824c0 7.059 2.353 12.353 8.235 17.059 5.294 5.294 10.588 7.647 16.471 7.647 4.118 0 7.647-0.588 10.588-2.941a98.088 98.088 0 0 0 8.824-8.235 80.559 80.559 0 0 0 4.706-8.235c1.765-2.941 3.529-6.471 5.294-10 1.176-2.941 2.941-6.471 4.118-10a38.4 38.4 0 0 1 4.706-10c8.235-14.118 17.647-24.706 28.235-32.941 10-7.647 24.118-11.765 41.765-11.765a69.788 69.788 0 0 1 27.059 5.882 82.831 82.831 0 0 1 21.765 15.882 92.786 92.786 0 0 1 14.122 22.941 71.518 71.518 0 0 1 5.294 27.059 95.714 95.714 0 0 1-5.294 32.352A143.025 143.025 0 0 1 561.294 482a160.888 160.888 0 0 1-17.647 25.294c-7.059 8.235-14.706 15.882-21.765 22.941L466 582.588c-18.235 17.647-37.647 34.118-57.647 50a178.261 178.261 0 0 0-15.294 13.53c-4.706 4.706-8.824 9.412-13.529 14.118a82.159 82.159 0 0 0-10 11.765 31.891 31.891 0 0 0-3.529 14.706c0 8.235 2.941 14.706 9.412 18.824 5.882 4.706 12.353 6.471 20 6.471a81.789 81.789 0 0 0 15.882-1.765l8.824-1.765c2.353-0.588 5.294-1.176 8.235-1.765 22.353-2.941 45.294-5.294 69.412-7.647q35.294-3.529 68.824-3.529a286.194 286.194 0 0 1 38.235 2.941c12.353 2.353 24.706 2.941 37.647 2.941 3.529 0 7.059-1.176 10.588-4.706a13.693 13.693 0 0 0 5.88-11.766z" fill="#FFFFFF" p-id="4639"></path>
                </svg>
              </span>
              <span>Send an SMS message to the number you have selected</span>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="mx-auto">
            <v-card elevation="2" class='py-4 px-4'>
              <span class="mr-2" style="vertical-align:middle;">
                <svg t="1680591213891" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5036" width="32" height="32">
                  <path d="M512 899.5c-213.668 0-387.5-173.832-387.5-387.5S298.332 124.5 512 124.5 899.5 298.332 899.5 512 725.668 899.5 512 899.5z" fill="#4472C4" p-id="5037"></path>
                  <path d="M512 137c-206.776 0-375 168.224-375 375s168.224 375 375 375 375-168.224 375-375-168.224-375-375-375m0-25c220.914 0 400 179.086 400 400S732.914 912 512 912 112 732.914 112 512s179.086-400 400-400z" fill="#4472C4" p-id="5038"></path>
                  <path d="M657.703 576.92a85.081 85.081 0 0 0-6.987-34.934 112.5 112.5 0 0 0-20.378-26.783 144.785 144.785 0 0 0-30.858-18.632 235.7 235.7 0 0 0-39.01-13.392c18.632-12.227 32.023-25.036 40.175-37.846 7.569-12.809 11.645-27.948 11.645-46q0-24.454-10.48-41.921a83.792 83.792 0 0 0-27.948-27.365 137.352 137.352 0 0 0-38.428-13.974c-13.974-2.329-27.948-4.076-41.921-4.076-11.063 0-22.707 1.747-34.935 4.076-12.809 3.493-23.872 6.987-34.352 11.645a112.161 112.161 0 0 0-26.2 16.3c-6.987 5.822-9.9 12.227-9.9 18.049 0 6.4 1.747 12.227 6.4 16.885q6.114 6.987 13.974 6.987c4.658 0 11.063-1.165 18.632-4.658l10.48-5.24c3.493-1.747 6.987-3.493 11.063-5.822 8.151-4.076 16.885-8.151 27.365-12.809a72.374 72.374 0 0 1 28.53-6.4c6.987 0 13.974 1.164 21.543 2.329a63.6 63.6 0 0 1 20.961 6.987A47.5 47.5 0 0 1 561.63 374.3a47.5 47.5 0 0 1 5.822 23.29c0 11.645-2.911 22.125-8.151 30.277a87.655 87.655 0 0 1-20.375 23.293c-8.151 6.4-16.3 11.645-25.036 15.138-9.316 4.076-16.885 6.987-23.29 8.151a73.787 73.787 0 0 1-19.8 2.329h-8.73c-5.822 0-11.063 1.165-16.3 2.329-5.822 1.747-9.316 3.493-11.063 5.24q-5.24 5.24-5.24 13.974c0 6.987 2.911 12.809 9.316 18.049 5.822 5.24 11.645 7.569 18.049 7.569a39.141 39.141 0 0 0 13.974-2.329 121.947 121.947 0 0 0 13.392-4.658 131.023 131.023 0 0 1 13.974-4.658 58.658 58.658 0 0 1 14.556-1.747 44.323 44.323 0 0 1 12.227 1.747 68.1 68.1 0 0 0 11.645 2.911 223.811 223.811 0 0 1 23.29 8.151 134.883 134.883 0 0 1 22.125 12.227 83.352 83.352 0 0 1 16.3 18.632 53.9 53.9 0 0 1 6.4 25.619c0 15.721-3.493 29.112-9.9 40.175a98.842 98.842 0 0 1-26.783 29.112 108.382 108.382 0 0 1-36.1 16.885 132.12 132.12 0 0 1-39.01 5.822c-14.556 0-30.277-2.911-46.579-9.316a62.636 62.636 0 0 1-16.885-7.569c-5.24-2.911-10.48-5.822-15.721-9.316-3.493-1.747-6.4-3.493-8.734-4.658a63.512 63.512 0 0 1-6.4-3.493c-4.658-2.329-8.734-4.076-11.645-4.076-5.822 0-10.48 2.329-14.556 6.4-4.658 4.076-6.4 9.316-6.4 15.721 0 6.987 2.329 13.392 7.569 18.049a46.313 46.313 0 0 0 15.719 12.811 149.475 149.475 0 0 0 25.036 9.9c9.316 3.493 19.214 5.822 29.694 8.151a264.49 264.49 0 0 0 29.694 5.24 132.026 132.026 0 0 0 24.454 2.329 180.016 180.016 0 0 0 57.06-9.316c18.632-5.822 36.1-13.974 51.237-25.619a145.407 145.407 0 0 0 37.263-42.5q13.975-24.458 13.975-57.646z" fill="#FFFFFF" p-id="5039"></path>
                </svg>
              </span>
              <span>Click "Read received SMS" for SMS</span>
            </v-card>
          </v-col>
        </v-col>
        <v-col cols="12" sm="12" md="2" lg="2" xl="2" v-if="$vuetify.breakpoint.smAndDown">
        </v-col>
        <v-col cols="12" sm="12" md="2" lg="2" xl="2" v-else>
          <!-- <AdsBar2 /> -->
        </v-col>
    </v-row>
    <v-row class="text-center">
      <v-col cols="12">
        <v-progress-linear color="deep-purple accent-4" indeterminate rounded height="6" :active="loading"></v-progress-linear>
      </v-col>
    </v-row>
    <v-row class="justify-center my-4" v-for="(group, index) in groupedPhoneNumbers" :key="index">
      <v-col v-for="(phoneNumber, index) in group" :key="index" cols="12" sm="12" md="3" lg="3" xl="3">
        <v-card elevation="2" class='pt-1'>
          <v-img :src="phoneNumber.icon" width="60%" class='mx-auto border1'></v-img>
          <v-row class="justify-center text-center">
            <v-card-text>
              <h3>{{phoneNumber.country}}</h3>
            </v-card-text>
          </v-row>
          <v-row class="justify-center my-2">
            <h2 class="mr-2">{{phoneNumber.phoneNo}}</h2>
            <v-icon @click="copyNumber(phoneNumber.phoneNo)">mdi-content-copy</v-icon>
          </v-row>
          <v-row class="justify-center text-center">
            <v-card-text>
              <h3 class="green--text">(Added: {{phoneNumber.added}})</h3>
            </v-card-text>
          </v-row>
          <v-row class="justify-center">
            <v-card-actions>
              <v-btn class='primary mx-auto' @click="handleClick(phoneNumber.country, phoneNumber.phoneNo,phoneNumber.sourceType,phoneNumber.sourceUrl)">Read Received SMS</v-btn>
            </v-card-actions>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="justify-center my-4">
      <v-col cols="12" sm="12" md="9" lg="9" xl="9">
        <div class="text-center">
          <v-pagination v-model=page :length=6 @input='handleNext'></v-pagination>
        </div>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbarStatus" :multi-line="true">{{ snackbarText }}</v-snackbar>
  </v-container>
</template>
<script>
import axios from 'axios'
// import AdsBar from '@/components/AdsBar';
// import AdsBar2 from '@/components/AdsBar2';
export default {
  name: 'AllView',
  data: () => ({
    phoneNumbers: [],
    loading:true,
    snackbarStatus: false,
    snackbarText: '',
    page:1
  }),
  components: {
    // AdsBar,
    // AdsBar2
  },
  computed: {
    currentCountry() {
      // let result={};
      // let path = this.$route.path.replace(/\//g, '');
      // if (path == 'All') {
      //   result= 'All Phone Numbers';
      // } else {
      //   result= path + " Phone Numbers";
      // }
      let result= 'All Phone Numbers';
      return result
    },
    currentPhoneNumbers() {
      // let result={};
      // let path = this.$route.path.replace(/\//g, '');
      // if (path == 'All') {
      //   result= this.phoneNumbers;
      // } else {
      //   result= this.phoneNumbers.filter(obj => obj.country === path);
      // }
      // return result
      return this.phoneNumbers
    },
    groupedPhoneNumbers() {
      const result = [];
      for (let i = 0; i < this.currentPhoneNumbers.length; i += 3) {
        result.push(this.currentPhoneNumbers.slice(i, i + 3));
      }
      return result;
    },
  },

  mounted() {
    // console.log("mounted")
    this.$watch(
      () => this.$route.params,
      (toParams, previousParams) => {
        if('page' in toParams){
          this.handleUpdate();  
        }
      }
    )
    this.handleUpdate();

  },
  // created() {
  //   this.$watch(
  //     () => this.$route.params,
  //     (toParams, previousParams) => {
  //       if('page' in toParams){
  //         this.handleUpdate();  
  //       }
  //     }
  //   )
  // },
  methods: {
    copyNumber(phoneNo) {
      navigator.clipboard.writeText(phoneNo);
    },
    handleClick(country, phoneNo, sourceType, sourceUrl) {
      const data = {
        "country": country,
        "phoneNo": phoneNo,
        "sourceType": sourceType,
        "sourceUrl": sourceUrl
      };
      // 对data进行可逆的编码为字符串
      const encodedData = btoa(JSON.stringify(data));
      const url = "/detail/info/" + encodedData;
      if (this.$route.path !== url) {
        // this.$router.push(url);
        this.$router.push({path:url});
      }
    },
    handleNext(){

      const url='/All/page/'+this.page;
      if (this.$route.path !== url) {
        this.$router.push({ path: url});
        // this.handleUpdate();
      }

    },
    handleUpdate(){
        // console.log("handleUpdate")
        this.loading = true;
        this.phoneNumbers=[]
        const currentPage=this.$route.params['page']
        // console.log(currentPage)
        this.page=Number(currentPage)
        let data={
          "page":this.page
        }
        axios.post('https://receivesmsapi.promptboom.org/getphonenumbers',data).then(res => {
        // axios.post('http://127.0.0.1:8787/getphonenumbers',data).then(res => {
          this.phoneNumbers = res['data'];
          // console.log(this.phoneNumbers)
        }).catch((error) => {
          console.log("error");
          this.snackbarStatus = 'true';
          this.snackbarText = "Network error,you can try again or contact us";
          setTimeout(function() {
            this.snackbarStatus = 'false';
            this.snackbarText = "";
          }, 1000);
        }).finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
  .my-custom-font-title {
    /* font-family: 'Pacifico', cursive; */
    font-family: 'Gasoek One', sans-serif;
    font-size: 100px;
  }
  .my-custom-font-explain {
    font-family: 'Geologica', sans-serif;
  }
  .border1{
    border: 1px solid #E7E7E7;
  }
</style>